import React, { useState } from 'react'
import { Alert, Button } from '@mui/material'
import { useFormik } from 'formik';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { assessmentSchema } from '../schemas';

const Assessment = ()=>{
    const uri = useSelector(state=>state.uri)
    const [response, setResponse] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const {handleBlur, handleChange, handleSubmit, handleReset, errors, touched, values} = useFormik({
        initialValues: {
            name: '',
            email: '',            
        },
        validationSchema: assessmentSchema,
        onSubmit: (values)=>{
            setResponse('')
            setIsLoading(true)
            axios.post(
                `${uri}records`,
                values
            ).then(res=>{
                handleReset()
                setIsLoading(false)
                setResponse(res.data.message)
            }).catch(err=>{
                console.log(err.response)
                err.response && err.response.data.message ? setResponse(err.response.data.message) : setResponse('Ensure you are connected to the internet')
                setIsLoading(false)
            })
        }
    })
    return (
        <div>
            {/* <Navbar /> */}
            <div className='d-flex justify-content-center my-5'>
                <div className='col-md-4 p-md-5 p-4 border mt-5 mx-2'>
                    <div className='d-flex justify-content-center mb-3'>
                        <img src={require('../assets/logo.png')} />
                    </div>
                    <p className='fs-5 text-center fw-semibold'>
                        YRH-OAU Intending Members
                    </p>  
                        {
                            response !== ''
                            ? 
                            <Alert severity={response.includes('recorded') ? 'success' : 'error'}>
                                {response}
                            </Alert>
                            :
                            ''
                        }                  
                    <div className='my-4'>
                        <input name='name' value={values.name} onChange={handleChange} onBlur={handleBlur} className='form-control form-control-lg fs-6' placeholder='Full Name' />
                        {errors.name && touched.name && <div className='text-danger'>{errors.name}</div>}
                    </div>
                    <div className='my-4'>
                        <input name="email" value={values.email} onChange={handleChange} onBlur={handleBlur} type='email' className='form-control form-control-lg fs-6' placeholder='Email' />
                        {errors.email && touched.email && <div className='text-danger'>{errors.email}</div>}
                    </div>
                    <Button disabled={isLoading} onClick={handleSubmit} className={isLoading ? 'border border-yrh text-yrh font-poppins fw-bold w-100 py-2' : 'bg-yrh text-white font-poppins fw-bold w-100 py-2'}>
                        {
                            isLoading
                            ?
                            'Submitting...'
                            :
                            'Submit'
                        }
                    </Button>
                    <p className='text-danger'>
                        Note: This information is very important for your upcoming Assessment Test
                    </p>
                </div>
            </div>
            {/* <Footer /> */}
        </div>
    )
}

export default Assessment